import React, { ReactElement } from 'react'

import { BoxProps } from '@mindfulchefuk/design-system/layout/Box'
import { Svg } from '../../Svg/Svg'

export const LeafIcon = (props: BoxProps): ReactElement => (
  <Svg viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M17.7642 18.1568C13.8806 17.0021 10.4744 14.6227 8.05368 11.3737C5.67113 8.14189 3.64165 4.66416 2 1C3.48097 1.81524 5.03912 2.48166 6.65158 2.98947C8.26627 3.49671 9.81016 4.20658 11.2463 5.10211C12.6886 6.01856 13.7568 7.41929 14.2589 9.05263C14.5117 10.0249 14.4888 11.0484 14.1926 12.0084C13.8774 12.9903 13.3011 13.868 12.5253 14.5474C11.1608 15.7121 9.34535 16.2025 7.58 15.8832C5.8156 15.5508 4.29295 14.4453 3.43053 12.8705C2.70496 11.2225 2.36476 9.43081 2.43579 7.63158"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
)
